import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import {
  generateBaseEntity,
  generateHtmlAttrId,
  generateId,
} from 'src/shared/entities/utils/generate-base-entity'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import {
  FormCheckboxInterface,
  FormElementTypeEnum,
  FormFieldInterface,
  FormInterface,
  FormLayoutEnum,
  FormSubmitButtonInterface,
} from 'src/shared/types/entities/form-interface'
import { RedirectionTypesEnum } from 'common/enums/ButtonActionEnum'

export const createFormField = (slug: ContactSlugEnum): FormFieldInterface => ({
  id: generateId(),
  elementType: FormElementTypeEnum.Field,
  slug,
  htmlAttrId: generateHtmlAttrId(FormElementTypeEnum.Field),
  placeholder: slug,
  optional: false,
})

export const createFormCheckbox = (): FormCheckboxInterface => ({
  id: generateId(),
  elementType: FormElementTypeEnum.Checkbox,
  htmlAttrId: generateHtmlAttrId(FormElementTypeEnum.Checkbox),
  content: 'Checkbox',
  errorText: 'Error text',
  optional: false,
})

export const createFormSubmitButton = (): FormSubmitButtonInterface => ({
  id: generateId(),
  elementType: FormElementTypeEnum.SubmitButton,
  htmlAttrId: generateHtmlAttrId(FormElementTypeEnum.SubmitButton),
  text: 'Submit',
})

// NOTE: this is a draft
const fieldsConfig = Object.values(ContactSlugEnum).map(slug => ({
  slug,
}))

export const createForm = (parentId: string, masterBlockId?: MasterBlockId) => {
  const entity: FormInterface = {
    ...generateBaseEntity(EntityTypeEnum.Form, parentId, masterBlockId),
    type: EntityTypeEnum.Form,
    layout: FormLayoutEnum.OneColumn,
    elements: [
      ...fieldsConfig.map(field => createFormField(field.slug)),
      createFormCheckbox(),
      createFormSubmitButton(),
    ],
    action: {
      redirectionType: RedirectionTypesEnum.none,
      doubleOptIn: false,
    },
    border: {
      width: 2,
      style: BorderStyleEnum.solid,
      color: '#18191C',
    },
    padding: {
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 10,
      paddingRight: 10,
    },
    margin: { marginTop: 0, marginBottom: 0, marginLeft: 0, marginRight: 0 },
    mobileMargin: {
      marginTop: 5,
      marginBottom: 5,
      marginLeft: 5,
      marginRight: 5,
    },
  }

  return entity
}
